module.exports = __webpack_public_path__ + "media/images/varta/BG_Auto-ae5058b8958f257e1a16f5426880f579.jpg";